import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Lieferant } from '../shared/lieferant.model';
import { BehaviorSubject } from 'rxjs';
 
@Injectable()
export class Data {
 
    public storage: any;
    private _lieferantSource = new BehaviorSubject<Lieferant>(null);
    lieferant$ = this._lieferantSource.asObservable();


    changeLieferant(lieferant: Lieferant){
        this._lieferantSource.next(lieferant);
    }

 
    public constructor() { 
    }
 
}